import { render } from "./ChatMessageList.vue?vue&type=template&id=0e0def67"
import script from "./ChatMessageList.vue?vue&type=script&lang=js"
export * from "./ChatMessageList.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__